// components
import type { BoxProps } from '@mui/material';
import { styled, Box } from '@mui/material';

export const StyledNoDataGridRowsBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  color: 'text.secondary',
  marginTop: theme.spacing(-4)
}));
